import { Location } from 'react-router-dom';

export const getCoreRoute = (location: Location): string => {
  return location.pathname.split('/')[1];
};
